import { CurrencyPipe } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-reimbursement-summary-widget",
  standalone: true,
  imports: [MaterialModule, TranslateModule, CurrencyPipe],
  templateUrl: "./dashboard-reimbursement-summary-widget.component.html",
  styleUrl: "./dashboard-reimbursement-summary-widget.component.scss",
})
export class DashboardReimbursementSummaryWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly totalReimbursement = input.required<number>();
  readonly totalCashReimbursement = input.required<number>();
  readonly totalInventoryReimbursement = input.required<number>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  navigateToReimbursementsReport(): void {
    this.navigationSvc.navigateToReimbursementsReport(this.listNavigation());
  }
}
